import Model from '../utils/Model'

export class ChargeServiceTypeItem {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
  static CODE_NAME = 'ChargeServiceItem';

  static CHARGE_SERVICE_BOOKING = new ChargeServiceTypeItem(1, 'Booking', '订舱');
  static CHARGE_SERVICE_CUSTOMS = new ChargeServiceTypeItem(2, 'Customs', '报关');
  static CHARGE_SERVICE_WAREHOUSING = new ChargeServiceTypeItem(3, 'Warehousing', '仓储');
  static CHARGE_SERVICE_CARRYING = new ChargeServiceTypeItem(4, 'Carrying', '运输');
  static CHARGE_SERVICE_OTHER = new ChargeServiceTypeItem(5, 'OTHER', '其它');

  static CHARGE_SERVICE_ITEMS = [this.CHARGE_SERVICE_BOOKING, this.CHARGE_SERVICE_CUSTOMS, this.CHARGE_SERVICE_WAREHOUSING, this.CHARGE_SERVICE_CARRYING, this.CHARGE_SERVICE_OTHER];

  /**
   *  return null:没找到.
   */
  static getChargeServiceItemByCode(code) {
    const item = Model.getObjByCode(code, ChargeServiceTypeItem.CHARGE_SERVICE_ITEMS)
    console.log('code=========', code, item)
    return item
  }
}
